import React, { memo, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@compiled/react';

import Spinner from '@atlaskit/spinner/spinner';

import { Comment } from '../Comment/Comment';

import { BATCH_SIZE } from './CommentsListBatch';
import { getComments } from './utils';

// Exported for testing
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpinnerContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	margin: 'auto',
	position: 'sticky',
	bottom: '1px',
});

// Exported for testing
export const SPINNER_DURATION = 100;

export const CommentBatch = memo((props) => {
	const { canRenderBatch, batchIndex, comments, genericProps, onBatchRendered } = props;
	const [showSpinner, setShowSpinner] = useState(false);

	useLayoutEffect(() => {
		if (canRenderBatch) {
			setShowSpinner(true);
			setTimeout(() => {
				onBatchRendered(batchIndex);
				setShowSpinner(false);
			}, SPINNER_DURATION);
		}
	}, [canRenderBatch, batchIndex, onBatchRendered]);

	if (!canRenderBatch) {
		return null;
	}

	const batchOffset = batchIndex * BATCH_SIZE;
	const batch = comments.slice(batchOffset, batchOffset + BATCH_SIZE);

	const elements = getComments(batch, props, genericProps, Comment);

	return (
		<>
			{elements}
			{showSpinner ? (
				<SpinnerContainer>
					<Spinner size="medium" />
				</SpinnerContainer>
			) : null}
		</>
	);
});

CommentBatch.propTypes = {
	batchIndex: PropTypes.number.isRequired,
	canRenderBatch: PropTypes.bool.isRequired,
	comments: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	genericProps: PropTypes.object,
	editor: PropTypes.object,
	userInfo: PropTypes.object,
	focusOnCommentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	highlightedComments: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	autoFocusedCommentId: PropTypes.string,
	onCommentAutoFocused: PropTypes.func,
	onBatchRendered: PropTypes.func.isRequired,
};
